"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAlabamaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'AL';

function getAlabamaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Private Pension Plans (Judges)',
    type: stateCode,
    statuteName: 'Ala. Code § 12-18-10',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.JUDGES_PENSIONS;
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation - $400 per week",
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ala. Code § 15-23-15 (e)',
    limitAggregateSingle: 15000,
    limitAggregateJoint: 30000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Private Pension Plans (Teachers)',
    type: stateCode,
    statuteName: 'Ala. Code § 16-25-23',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.TEACHERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Spendthrift Trust',
    type: stateCode,
    statuteName: 'Ala. Code § 19-3B-501; Ala. Code § 19-3B-502; Ala. Code § 19-3B-503',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SPENDTHRIFT_TRUST;
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA & Roth IRA',
    type: stateCode,
    statuteName: 'Ala. Code § 19-3B-508',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.ROTH_IRA || subType === _subTypes.IRA);
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Ala. Code § 25-4-140',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: "Worker's Compensation",
    type: stateCode,
    statuteName: 'Ala. Code § 25-5-86',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability Insurance Proceeds - avarage $250 per month',
    type: stateCode,
    statuteName: 'Ala. Code § 27-14-31',
    limitAggregateSingle: 250,
    limitAggregateJoint: 250,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.PROCEEDS_FROM_HEALTH_OR_DIABILITY_INSURANCE_CLAIM];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuities - to $250 per month',
    type: stateCode,
    statuteName: 'Ala. Code § 27-14-32',
    limitAggregateSingle: 250,
    limitAggregateJoint: 250,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.ANNUITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Ala. Code § 31-2-78; Ala. Code § 6-10-126 (a)(4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'State Military Arms, Uniforms, Equipment',
    type: stateCode,
    statuteName: 'Ala. Code § 31-2-78; Ala. Code § 6-10-126 (a)(4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.UNIFORMS || subType === _subTypes.MILITARY_EQUIPMENT);
    }
  }, {
    id: idCounter.increment(),
    description: 'Private Pension Plans (Police Officers)',
    type: stateCode,
    statuteName: 'Ala. Code § 36-21-77',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.POLICE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Private Pension Plans (State Employees)',
    type: stateCode,
    statuteName: 'Ala. Code § 36-27-28',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.STATE_EMPLOYEES_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Earned Income Tax Credit',
    type: stateCode,
    statuteName: 'Ala. Code § 38-4-8; Ala. Code § 38-5-5',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.INCOME_TAX_CREDIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unpaid Wages - 75% of weekly net earnings',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ala. Code § 5-19-15; Ala. Code § 6-10-7',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: "Vehicle used by and essential to the debtor's business",
    type: stateCode,
    statuteName: 'Ala. Code § 6-10-126 (a)(3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.BUSINESS_VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Books, Antiques, Art, Collectibles. Wearing Apparel',
    type: stateCode,
    statuteName: 'Ala. Code § 6-10-6',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.BOOK || subType === _subTypes.ANTIQUE || subType === _subTypes.ARTWORK || subType === _subTypes.COLLECTIBLES || subType === _subTypes.CLOTHES);
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (Proceeds and 100% of Cash Value)',
    type: stateCode,
    statuteName: 'Ala. Code § 6-10-8; Ala. Code § 27-14-29',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PROCEEDS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Benefits, Societal Benefits',
    type: stateCode,
    statuteName: 'Ala. Code § 6-10-8; Ala. Code § 27-34-27; Ala. Code § 27-14-29',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.FRATERNAL_BENEFIT];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnership Property',
    type: stateCode,
    statuteName: 'Ala. Code § 6-10-9; Ala. Code § 10-8A-501',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.PARTNERSHIP_PROPERTY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Crops: Growing or Ungathered',
    type: stateCode,
    statuteName: 'Ala. Code § 6-9-41',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CROPS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods and Furnishings',
    type: stateCode,
    statuteName: 'Ala. Code § 6-10-6; Ala. Code § 6-10-126',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && [_subTypes.ELECTRONICS, _subTypes.HOUSEHOLD].includes(subType);
    }
  }, {
    id: _Rule.WILDCARD_ID,
    type: stateCode,
    description: 'Wildcard',
    statuteName: 'Ala. Code § 6-10-6; Ala. Code § 6-10-126',
    limitAggregateSingle: 7500,
    limitAggregateJoint: 15000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}